import React, { useState } from "react";
import { PageHeader, Upload, Button, Icon, notification } from "antd";
import {
  uploadTemplateUserApi,
  downloadTemplateUserApi,
} from "../../../api/user";
import { getAccesTokenApi } from "../../../api/auth";

import "./UploadUsers.scss";

export default function UploadUsers() {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const token = getAccesTokenApi();

  const handleUpload = () => {
    setUploading(true);

    uploadTemplateUserApi(token, fileList).then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla cargada Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error cargando plantilla: " + response,
        });
      }
      setFileList([]);
      setUploading(false);
    });
  };

  const downloadTemp = () => {
    setDownloading(true);

    downloadTemplateUserApi().then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla descargada Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error descargando plantilla",
        });
      }
      setDownloading(false);
    });
  };

  const properties = {
    onRemove: (file) => {
      /*const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			fileList = newFileList;*/
      setFileList([]);
    },
    beforeUpload: (file) => {
      if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFileList([...fileList, file]);
        return false;
      } else {
        setFileList([]);
        notification["error"]({
          message: "Solo se permitem plantillas en formato de Excel (XLSX)",
        });
      }
    },
    fileList,
  };

  return (
    <div className="upload-users">
      <PageHeader
        /*onBack={() => null}*/ title="Cargar plantilla"
        subTitle=" de cargue masivo de usuarios"
      />
      <Upload {...properties}>
        <Button disabled={fileList.length === 1}>
          <Icon type="upload" /> Seleccione Plantilla
        </Button>
      </Upload>
      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        style={{ marginTop: 16 }}
      >
        {uploading ? "Cargando plantilla..." : "Iniciar carga"}
      </Button>
      <Button
        type="danger"
        onClick={downloadTemp}
        loading={downloading}
        style={{ marginTop: 16, marginLeft: 10 }}
      >
        <Icon type="download" />{" "}
        {downloading ? "Descargando plantilla..." : "Descargar Plantilla"}
      </Button>
    </div>
  );
}
